<app-dialog-header titleTranslateKey="scheduler.setup.roster.add-assignment.title" (closeClicked)="cancel()">
</app-dialog-header>

<form (ngSubmit)="submit()" [formGroup]="assignmentForm">
  <mat-dialog-content class="fullscreen-dialog">
    @if (assignmentForm.value.resource) {
    <div class="resource-profile">
      <div class="profile-image">
        <img alt="Resource profile picture" src="{{assignmentForm.value.resource.imageUrl || 'assets/profile.png'}}" />
      </div>
      <span class="resource-name">{{ assignmentForm.value.resource.name }}</span>
    </div>
    }

    <div class="resource-selection">
      <button (click)="chooseResource()" color="primary" mat-raised-button type="button">
        <mat-icon fontIcon="fa-user-edit" fontSet="fas"></mat-icon>
        Choose Resource
      </button>
    </div>

    <div class="form-fields-container">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Division*</mat-label>
        <mat-select formControlName="subDivision">
          @for (division of data.subDivisions; track division) {
          <mat-option [value]="division">{{ division.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Start Date*</mat-label>
        <input [matDatepicker]="startPicker" formControlName="startDate" matInput aria-label="Start date input field">
        <mat-datepicker-toggle [for]="startPicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field">
        <mat-label>End Date</mat-label>
        <input [matDatepicker]="endPicker" formControlName="endDate" matInput aria-label="End date input field">
        <mat-datepicker-toggle [for]="endPicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button [disabled]="!assignmentForm.valid" color="primary" mat-raised-button type="submit">Save</button>
  </mat-dialog-actions>
</form>